var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.removedIds, function (id, removedIndex) {
        return _c("input", {
          key: removedIndex,
          attrs: { type: "hidden", name: _vm.removedName + "[]" },
          domProps: { value: id },
        })
      }),
      _vm._v(" "),
      _c(
        "table",
        { staticClass: "w-100" },
        [
          _c("thead", [
            _c(
              "tr",
              [
                _c("th", [_vm._v(" ")]),
                _vm._v(" "),
                _vm._l(_vm.columns, function (column, index) {
                  return _c("th", { key: index, staticClass: "p-1" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.__(column)) + "\n        "
                    ),
                  ])
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "draggable",
            {
              attrs: {
                value: _vm.elements,
                tag: "tbody",
                handle: ".draggable-handle",
              },
              on: { update: _vm.handleMove },
            },
            [
              _vm._l(_vm.elements, function (element, index) {
                return _c(
                  "tr",
                  { key: index },
                  [
                    _c(
                      "td",
                      {
                        staticClass: "p-1 draggable-handle",
                        staticStyle: {
                          width: "24px",
                          "font-size": "22px",
                          cursor: "move",
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-bars" }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", name: _vm.idName + "[]" },
                          domProps: { value: element[_vm.idName] },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", name: _vm.orderName + "[]" },
                          domProps: { value: index },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.columns, function (column) {
                      return _c("td", { key: index, staticClass: "p-1" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: element[column],
                              expression: "element[column]",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", name: column + "[]" },
                          domProps: { value: element[column] },
                          on: {
                            keydown: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "down",
                                    40,
                                    $event.key,
                                    ["Down", "ArrowDown"]
                                  )
                                )
                                  return null
                                return _vm.focusIndex(index + 1)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.focusIndex(index + 1)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k($event.keyCode, "up", 38, $event.key, [
                                    "Up",
                                    "ArrowUp",
                                  ])
                                )
                                  return null
                                return _vm.focusIndex(index - 1)
                              },
                            ],
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(element, column, $event.target.value)
                            },
                          },
                        }),
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "p-1", staticStyle: { width: "1%" } },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn red",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.removeElement(index)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa fa-times" })]
                        ),
                      ]
                    ),
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  { staticClass: "p-1", staticStyle: { width: "24px" } },
                  [_vm._v(" ")]
                ),
                _vm._v(" "),
                _c("td", { staticClass: "p-1" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn blue w-100",
                      staticStyle: { display: "block" },
                      attrs: { type: "button" },
                      on: { click: _vm.addElement },
                    },
                    [_vm._v(" Ajouter ")]
                  ),
                ]),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }